import PropTypes from "prop-types";

export default PropTypes.shape({
  currentCompany: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  selectableCompany: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  selectedCompany: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
});
